import { useEffect, useState } from "react";

export function useIsInDayRange(
  isoDateWithoutTimeStart,
  isoDateWithoutTimeEnd
) {
  const [isInDayRange, setIsInDayRange] = useState(null);
  useEffect(() => {
    const today = new Date();
    const dayStart = new Date(isoDateWithoutTimeStart ?? new Date());
    const dayEnd = new Date(isoDateWithoutTimeEnd ?? new Date());

    // Set dates to midnight
    today.setHours(0, 0, 0, 0);
    dayStart.setHours(0, 0, 0, 0);
    dayEnd.setHours(0, 0, 0, 0);

    if (today >= dayStart && today <= dayEnd) {
      setIsInDayRange(true);
    } else {
      setIsInDayRange(false);
    }
  }, [isoDateWithoutTimeStart, isoDateWithoutTimeEnd]);
  return isInDayRange;
}
